import { Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const QrPopup = () => {
  const { t } = useTranslation(['payment', 'common']);
  return (
    <Stack gap={'var(--mantine-spacing-lg)'}>
      <video
        style={{ borderRadius: 'var(--mantine-radius-xl)' }}
        autoPlay
        playsInline
        muted
        loop
        id="qrVideo"
      >
        <source src={'../../../../assets/videos/test.mp4'} type={'video/mp4'} />
        Your browser does not support the html video tag.
      </video>
      <Text variant="white">{t('qr_help_paragraph_1')}</Text>
      <Text variant="white">{t('qr_help_paragraph_2')}</Text>
    </Stack>
  );
};
